import { render, staticRenderFns } from "./SuppliesTable.vue?vue&type=template&id=c927ccfc&scoped=true&lang=pug"
import script from "./SuppliesTable.vue?vue&type=script&lang=js"
export * from "./SuppliesTable.vue?vue&type=script&lang=js"
import style0 from "./SuppliesTable.vue?vue&type=style&index=0&id=c927ccfc&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c927ccfc",
  null
  
)

export default component.exports